import { Theme, themes } from '../types';
import { Switch } from './Switch';

interface PomodoroSettingsProps {
  workDuration: number;
  shortBreakDuration: number;
  longBreakDuration: number;
  autoStartBreaks: boolean;
  autoStartPomodoros: boolean;
  longBreakInterval: number;
  onWorkDurationChange: (duration: number) => void;
  onShortBreakDurationChange: (duration: number) => void;
  onLongBreakDurationChange: (duration: number) => void;
  onAutoStartBreaksChange: (enabled: boolean) => void;
  onAutoStartPomodorosChange: (enabled: boolean) => void;
  onLongBreakIntervalChange: (interval: number) => void;
  theme: typeof themes[Theme];
}

export function PomodoroSettings({
  workDuration,
  shortBreakDuration,
  longBreakDuration,
  autoStartBreaks,
  autoStartPomodoros,
  longBreakInterval,
  onWorkDurationChange,
  onShortBreakDurationChange,
  onLongBreakDurationChange,
  onAutoStartBreaksChange,
  onAutoStartPomodorosChange,
  onLongBreakIntervalChange,
  theme
}: PomodoroSettingsProps) {
  return (
    <div className="space-y-6">
      <div>
        <h3 className={`text-sm font-medium mb-4 ${theme.text}`}>Time (minutes)</h3>
        <div className="grid grid-cols-3 gap-4">
          <div>
            <label className={`block text-sm ${theme.textMuted} mb-2`}>Pomodoro</label>
            <input
              type="number"
              min="1"
              max="60"
              value={Math.floor(workDuration / 60)}
              onChange={(e) => onWorkDurationChange(parseInt(e.target.value) * 60)}
              className={`w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 ${theme.border} ${theme.ring} ${theme.text} ${theme.card}`}
            />
          </div>
          <div>
            <label className={`block text-sm ${theme.textMuted} mb-2`}>Short Break</label>
            <input
              type="number"
              min="1"
              max="60"
              value={Math.floor(shortBreakDuration / 60)}
              onChange={(e) => onShortBreakDurationChange(parseInt(e.target.value) * 60)}
              className={`w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 ${theme.border} ${theme.ring} ${theme.text} ${theme.card}`}
            />
          </div>
          <div>
            <label className={`block text-sm ${theme.textMuted} mb-2`}>Long Break</label>
            <input
              type="number"
              min="1"
              max="60"
              value={Math.floor(longBreakDuration / 60)}
              onChange={(e) => onLongBreakDurationChange(parseInt(e.target.value) * 60)}
              className={`w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 ${theme.border} ${theme.ring} ${theme.text} ${theme.card}`}
            />
          </div>
        </div>
      </div>

      <div className="space-y-4">
        <div className="flex items-center justify-between">
          <label className={`text-sm ${theme.text}`}>Auto Start Breaks</label>
          <Switch checked={autoStartBreaks} onChange={onAutoStartBreaksChange} theme={theme} />
        </div>
        <div className="flex items-center justify-between">
          <label className={`text-sm ${theme.text}`}>Auto Start Pomodoros</label>
          <Switch checked={autoStartPomodoros} onChange={onAutoStartPomodorosChange} theme={theme} />
        </div>
      </div>

      <div>
        <label className={`block text-sm ${theme.text} mb-2`}>Long Break Interval</label>
        <input
          type="number"
          min="1"
          max="10"
          value={longBreakInterval}
          onChange={(e) => onLongBreakIntervalChange(parseInt(e.target.value))}
          className={`w-24 px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 ${theme.border} ${theme.ring} ${theme.text} ${theme.card}`}
        />
      </div>
    </div>
  );
}